import { Flex } from '@chakra-ui/react';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { TextArea } from '@morressier/alembic';
import { FieldLabel } from 'src/components/Field';
import { SUBTITLE_CHARACTER_LIMIT } from '../constants';
import { trimLeadingWhitespace, validateLabelWhenNoContent } from '../helpers';
import { FieldFormValues } from '../../../helpers/articleTypeConfig.types';

type Props = {
  control: Control<FieldFormValues>;
  errors: FieldErrors<FieldFormValues>;
  isFormDisabled: boolean;
};

const LabelSubtitleField: React.FC<Props> = ({
  control,
  errors,
  isFormDisabled
}) => {
  return (
    <Flex direction="column" gap={2}>
      <FieldLabel label="Subtitle" subText="" isRequired={false} />

      <Controller
        name="labelSubtitle"
        control={control}
        rules={{
          validate: value =>
            validateLabelWhenNoContent({
              value,
              label: 'Subtitle',
              isDisabled: isFormDisabled,
              isRequired: false
            }),
          maxLength: {
            value: SUBTITLE_CHARACTER_LIMIT,
            message: `Subtitle cannot exceed ${SUBTITLE_CHARACTER_LIMIT} characters`
          }
        }}
        render={({ field }) => (
          <TextArea
            name={field.name}
            value={field.value}
            onChange={event =>
              field.onChange(trimLeadingWhitespace(event.target.value))
            }
            placeholder="Label subtitle"
            resize="vertical"
            characterLimit={SUBTITLE_CHARACTER_LIMIT}
            isInvalid={!isFormDisabled && Boolean(errors.labelSubtitle)}
            errorMessage={
              !isFormDisabled ? errors.labelSubtitle?.message : undefined
            }
            isReadOnly={isFormDisabled}
          />
        )}
      />
    </Flex>
  );
};

export default LabelSubtitleField;
